var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portal"},[_c('portal-header'),(_vm.canSwitchLoans)?_c('active-loan-selector'):_vm._e(),_c('div',{staticClass:"pt-6"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }